import { useBasename as withBasename } from 'history';
import { browserHistory } from 'react-router';

export const history = withBasename(() => browserHistory)({
  basename: import.meta.env.BASE_URL,
});

export const navigate = (path: string): void => {
  history.push(path);
};

export const goBack = (): void => {
  history.goBack();
};
